import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import { WebSocketLink } from "@apollo/client/link/ws";

const cache = new InMemoryCache({
  typePolicies: {
    Subscription: {
      fields: {
        notifications: {
          merge(existing = [], incoming) {
            return [...existing, ...incoming];
          },
        },
        messages: {
          merge(existing = [], incoming) {
            return [...existing, ...incoming];
          },
        },
      },
    },
  },
});

const link = new WebSocketLink({
  uri:
    process.env.NODE_ENV === "production"
      ? `wss://zabschedule.herokuapp.com/`
      : "ws://localhost:4000/",
  options: {
    reconnect: true,
  },
});

const client = new ApolloClient({
  link,
  uri:
    process.env.NODE_ENV === "production"
      ? `https://zabschedule.herokuapp.com/`
      : "http://localhost:4000/",
  cache,
});
ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <React.StrictMode>
        <Router>
          <App />
        </Router>
      </React.StrictMode>
    </ApolloProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
